/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPipeModule } from '@shared/pipes/pipes.modules';
import { SharedToolkitBLIconComponent } from './bl-icon/bl-icon.component';
import { SharedToolkitDatepickerComponent } from './datepicker/datepicker.component';
import { SharedToolkitPageTitleComponent } from './page-title/page-title.component';
import { SharedToolkitSelectMultiplaComponent } from './select-multipla/select-multipla.component';
import { SharedToolkitTableSortComponent } from './table-sort/table-sort.component';
import { SharedToolkitUploadFileComponent } from './upload-file/upload-file.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        SharedPipeModule,
    ],
    declarations: [
        SharedToolkitBLIconComponent,
        SharedToolkitDatepickerComponent,
        SharedToolkitPageTitleComponent,
        SharedToolkitSelectMultiplaComponent,
        SharedToolkitTableSortComponent,
        SharedToolkitUploadFileComponent,
    ],
    exports: [
        SharedToolkitBLIconComponent,
        SharedToolkitDatepickerComponent,
        SharedToolkitPageTitleComponent,
        SharedToolkitSelectMultiplaComponent,
        SharedToolkitTableSortComponent,
        SharedToolkitUploadFileComponent
    ],
})
export class SharedToolkitModule { }
